<style scoped lang="scss">
.review-container {
    padding: 5px;
    border: thin solid #999;
    margin: 5px 0;

    .review-title, .review-question {
        font-size: 0.8em;
        color: #666;
    }
}
</style>

<template>
    <div class="uk-width-1-1 uk-grid">
        <header-row/>
        <div class="uk-width-1-1 uk-margin-bottom">
            <h2>Review Results:</h2>

            <div class="uk-grid uk-margin-remove" v-for="review in reviews">
                <div class="uk-width-1-1">
                    <h3>{{ review.review_name }}</h3>
                </div>
                <div class="uk-width-1-1 review-container" v-for="item in review.items" v-if="item.answer">
                    <div class="review-title">{{ item.review_name}}</div>
                    <div class="review-question">{{ item.question }}</div>
                    <div class="review-answer">
                        <span v-if="item.answered_by" style="font-weight: bold;">
                            {{ item.answered_by.name }}:
                        </span>
                        {{ item.answer }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import HeaderRow from "./HeaderRow";

    export default {
        name: "ReviewResults",
        components: {HeaderRow},
        computed: {
            ...mapState('Application', {
                assets: 'assets',
                application: 'application',
                applicant: 'applicant',
                hhMembers: 'hhMembers',
                documentRequests: 'documentRequests',
                documents: 'documents',
                renterManager: 'renterManager',
                landlordConfirmations: 'landlordConfirmations',
            }),
            ...mapGetters('Application', {
                headOfHousehold: 'headOfHousehold'
            }),
            ...mapState('ApplicationReview', {
                reviews: state => state.data,
                didFetch: 'didFetch',
            })
        },
        mounted() {
            if (!this.didFetch)
            {
                this.$store.dispatch('ApplicationReview/fetch', {
                    applicationId: this.application.id,
                    applicantId: this.application.applicant_user_id,
                })
            }
        }
    }
</script>
